/* ============================================
   TRADING JOURNAL PRO - MONKEY DFX
   Configuraci�n COMPLETA con Sistema de Expiraci�n
   ============================================ */
import { 
    parseMetaTraderFile,
    calculatePercentageResults as calculatePercentages,
    validateMetaTraderFile,
    calculateTradeStatistics
} from './mt-parser.js';


export { 
    parseMetaTraderFile,
    calculatePercentages as calculatePercentageResults,
    validateMetaTraderFile,
    calculateTradeStatistics,
    getUserAccess,
    R2_EBOOKS_URL,
    EBOOK_FILENAME,
    WORKER_URL as API_BASE_URL
};

const WORKER_URL = 'https://trading-journal-preprod.monkeydfx-trader.workers.dev';

// ============================================
// PAYPAL CONFIG (frontend)
// ============================================
try {
    const livePlanIds = {
        pro: 'P-4DD15673FE189681NNFYRCSA',
        unlimited: 'P-38684451E9611115UNFYRCSI'
    };

    const livePromoPlanIds = {
        // Claves simples (compatibilidad hacia atrás)
        pro: 'P-52774772X7091491LNIDMIZY',
        unlimited: 'P-6YL03434BG578664ENIDMIZY',
        // 50% descuento
        pro_50: 'P-52774772X7091491LNIDMIZY',
        unlimited_50: 'P-6YL03434BG578664ENIDMIZY',
        // 95% descuento
        pro_95: 'P-3DL47559SF5612216NIDMIZY',
        unlimited_95: 'P-99T81490FM364353VNIDMI2A',
    };
    const liveClientId = 'AR76O0QXMW-nrJPJk2uODVskav3cvrBSqy8oy72RY3BL8wqsPaW1uRf_ojXDZK2Mv2bSs3vzOp8TXKgo';

    window.PAYPAL_ENV = 'live';
    window.PAYPAL_CURRENCY = window.PAYPAL_CURRENCY || 'EUR';
    window.PAYPAL_PLAN_IDS = livePlanIds;
    window.PAYPAL_CLIENT_ID = liveClientId;
    window.PAYPAL_PROMO_PLAN_IDS = livePromoPlanIds;
    window.PAYPAL_PROMO_CODE = window.PAYPAL_PROMO_CODE || 'TFX20';

    window.LEMON_CHECKOUT_URLS = window.LEMON_CHECKOUT_URLS || {
        pro: '',
        unlimited: ''
    };
    window.LEMON_ENABLED = window.LEMON_ENABLED || false;
} catch (e) {}

// ?? R2 EBOOKS STORAGE (Cloudflare R2)
// Configura tu Public Bucket URL despu�s de crear el bucket en Cloudflare R2
const R2_EBOOKS_URL = 'https://pub-00e64b852dc04e3a8f102fa3d81f8bda.r2.dev';
const EBOOK_FILENAME = 'Ebook-Gestion-de-Riesgo-MDFX.pdf';

// ?? ENABLE_AUTO_MIGRATIONS: Controla si se ejecutan migraciones autom�ticas del esquema
// - true: Ejecuta CREATE TABLE / ALTER TABLE en cada cliente (�til para desarrollo)
// - false: Asume que las tablas ya existen (recomendado en producci�n)
// Solo activar si necesitas actualizar el esquema de la base de datos
const ENABLE_AUTO_MIGRATIONS = false;

// Client-side schema version to avoid running migrations on every page load.
// Bump this when altering/adding tables or indexes so clients run migrations once.
const DB_SCHEMA_VERSION = '1.1'; // 1.1: Added entry models support

// ============================================
// ?? PLANES Y L�MITES DE CUENTAS
// ============================================
const ACCOUNT_LIMITS = {
    'free': 2,      // Free: 1 cuenta
    'pro': 5,       // Pro: 5 cuentas
    'unlimited': Infinity // Unlimited: sin l�mite
};

const DEFAULT_PLAN = 'free';

// ============================================
// SANITIZACION DE ERRORES - No mostrar detalles SQL/tecnicos al cliente
// ============================================
window.getSafeErrorMessage = function getSafeErrorMessage(error) {
    if (error?.safeMessage) return error.safeMessage;
    if (error?.userMessage) return error.userMessage;
    const errorStr = (error?.message || String(error)).toLowerCase();
    
    // Detectar errores SQL y mostrar mensaje genérico
    if (errorStr.includes('sql') || 
        errorStr.includes('foreign key') || 
        errorStr.includes('constraint') ||
        errorStr.includes('database') ||
        errorStr.includes('query') ||
        errorStr.includes('syntax')) {
        return 'Ocurrió un error procesando tu solicitud. Por favor intenta de nuevo.';
    }
    
    // Detectar errores de red
    if (errorStr.includes('network') || errorStr.includes('fetch')) {
        return 'Error de conexion. Verifica tu conexion a internet.';
    }
    
    // Detectar errores de autenticación
    if (errorStr.includes('unauthorized') || errorStr.includes('forbidden')) {
        return 'No tienes permisos para realizar esta accion.';
    }
    
    // Para otros errores, mostrar un mensaje genérico
    return 'Ocurrió un error. Por favor intenta de nuevo.';
};

// ============================================
// USER ACCESS HELPERS (SESSION + LOCAL)
// ============================================
function readStorageValue(key) {
    try {
        return sessionStorage.getItem(key) || localStorage.getItem(key) || '';
    } catch (e) {
        return '';
    }
}

function getUserAccess() {
    const rawPlan = readStorageValue('userPlan') || readStorageValue('plan') || readStorageValue('tfx_plan') || DEFAULT_PLAN;
    const rawType = readStorageValue('userType') || readStorageValue('dbUserType') || 'user';
    const userPlan = String(rawPlan).toLowerCase().trim();
    const userType = String(rawType).toLowerCase().trim();
    const isLoggedIn = !!(readStorageValue('currentUserId'));
    return { userPlan, userType, isLoggedIn };
}

window.getUserAccess = getUserAccess;

// ============================================
// GLOBAL MODAL SCROLL LOCK
// ============================================
function isModalVisible(modal) {
    if (!modal) return false;
    if (modal.classList && modal.classList.contains('hidden')) return false;
    if (modal.getAttribute && modal.getAttribute('aria-hidden') === 'true') return false;
    const style = window.getComputedStyle(modal);
    if (!style) return false;
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
}

function updateBodyModalLock() {
    const modals = document.querySelectorAll('.modal, [id$="Modal"]');
    const open = Array.from(modals).some(isModalVisible);
    document.body.classList.toggle('modal-open', open);
}

if (typeof window !== 'undefined') {
    let rafId = null;
    const scheduleUpdate = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
            rafId = null;
            updateBodyModalLock();
        });
    };

    const observer = new MutationObserver(scheduleUpdate);
    window.addEventListener('DOMContentLoaded', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);
    observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
    });
}

// ============================================
// ?? RESTRICCIONES DE M�TRICAS POR PLAN
// ============================================
const METRICS_RESTRICTIONS = {
    'free': {
        // Metricas disponibles en plan Free
        available: ['totalTrades', 'winRate', 'totalProfitUSD', 'profitFactor'],
        // Metricas bloqueadas (mostrar "Upgrade para ver")
        blocked: ['bestTrade', 'bestTradePair', 'bestHour', 'rMultipleRatio', 'maxR'],
        message: 'Plan: Pro+ necesario'
    },
    'pro': {
        // M�tricas disponibles en plan Pro
        available: ['totalTrades', 'winRate', 'totalProfitUSD', 'profitFactor', 
                   'bestTrade', 'bestTradePair', 'bestHour', 'rMultipleRatio', 'maxR'],
        blocked: [],
        message: null
    },
    'unlimited': {
        // Todas las m�tricas disponibles
        available: ['totalTrades', 'winRate', 'totalProfitUSD', 'profitFactor', 
                   'bestTrade', 'bestTradePair', 'bestHour', 'rMultipleRatio', 'maxR'],
        blocked: [],
        message: null
    }
};

// ============================================
// ?? RATE LIMITING Y VALIDACI�N DE SEGURIDAD
// ============================================
// Rate limiting basado en localStorage
// Evita ataques de fuerza bruta en login/registro










// Validaci�n de username
function validateUsername(username) {
    // Validaci�n de longitud
    if (!username || username.length < 2 || username.length > 50) {
        return { valid: false, error: 'Username debe tener 2-50 caracteres' };
    }
    
    // Validar caracteres permitidos (solo alfanum�ricos, gui�n y gui�n bajo)
    if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
        return { valid: false, error: 'Username solo puede contener letras, n�meros, _ y -' };
    }
    
    // Prevenir usernames reservados
    const reservedNames = ['admin', 'system', 'root', 'test', 'null', 'undefined', 
                          'anonymous', 'guest', 'support', 'admin123', 'administrator'];
    if (reservedNames.includes(username.toLowerCase())) {
        return { valid: false, error: 'Este username no est� disponible' };
    }
    
    return { valid: true };
}

// Validaci�n mejorada de email (RFC 5322 simplificado)
function validateEmailFormat(email) {
    // Validaci�n b�sica pero robusta
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email)) {
        return { valid: false, error: 'Email no v�lido' };
    }
    
    // Validaciones adicionales
    if (email.length > 254) {
        return { valid: false, error: 'Email muy largo' };
    }
    
    const [localPart, domain] = email.split('@');
    
    if (localPart.length > 64) {
        return { valid: false, error: 'Email no v�lido' };
    }
    
    // Prevenir emails con caracteres inv�lidos
    if (/[<>()[\]\\,;:\s]/.test(email)) {
        return { valid: false, error: 'Email contiene caracteres inv�lidos' };
    }
    
    // Prevenir dominios conocidos como spam (opcional)
    const spamDomains = ['tempmail.com', '10minutemail.com', 'guerrillamail.com'];
    if (spamDomains.includes(domain.toLowerCase())) {
        return { valid: false, error: 'Este dominio de email no es permitido' };
    }
    
    return { valid: true };
}

// ============================================
// ??? CLIENTE TURSO SEGURO VIA WORKER
// ============================================
class SecureTursoClient {
    constructor(workerUrl) {
        this.workerUrl = workerUrl;
    }

    async execute({ sql, args = [] }) {
        const userToken = sessionStorage.getItem('tfx_token') ||
                         sessionStorage.getItem('tfx_authToken') ||
                         sessionStorage.getItem('userToken') ||
                         localStorage.getItem('tfx_token') ||
                         localStorage.getItem('userToken');
        
        if (!userToken) {
            throw new Error('No user token found');
        }

        // Optional performance logging for slow queries. Enable by setting
        // window.__PERF_LOG = true in the console during debugging.
        const perfEnabled = typeof window !== 'undefined' && !!window.__PERF_LOG;
        const startTs = perfEnabled ? performance.now() : 0;

        try {
            const response = await fetch(`${this.workerUrl}/api/execute`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`
                },
                body: JSON.stringify({ sql, args })
            });

            if (perfEnabled) {
                const took = Math.round((performance.now() - startTs));
            }

            if (response.status === 401 || response.status === 403) {
                const errorData = await response.json().catch(() => ({ error: response.statusText }));
                const rawError = String(errorData?.error || errorData?.message || response.statusText || '').toLowerCase();
                const isAuthRelated403 = response.status === 403 && (
                    rawError.includes('unauthorized') ||
                    rawError.includes('invalid token') ||
                    rawError.includes('token expired') ||
                    rawError.includes('expired token') ||
                    rawError.includes('missing token') ||
                    rawError.includes('missing authorization') ||
                    rawError.includes('invalid or expired token')
                );

                if (response.status === 401 || isAuthRelated403) {
                    try { handleUnauthorizedSession(); } catch (e) {}
                    // AUTO-SYNC: Intentar sincronización completa para recuperar trades
                    if (typeof window !== 'undefined' && window.doFullRefresh && typeof window.doFullRefresh === 'function') {
                        try {
                            await window.doFullRefresh();
                        } catch (syncErr) {
                            // Sync failed, fallback already handled
                        }
                    }
                }

                throw new Error(errorData.error || errorData.message || 'Unauthorized');
            }

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: response.statusText }));
                throw new Error(errorData.error || 'Query failed');
            }

            return await response.json();
        } catch (error) {
            // Network error - worker is down or unreachable
            throw error;
        }
    }
}

function handleUnauthorizedSession() {
    try {
        if (window.SessionValidator && typeof window.SessionValidator.clearSession === 'function') {
            window.SessionValidator.clearSession();
        } else if (typeof SessionValidator !== 'undefined' && typeof SessionValidator.clearSession === 'function') {
            SessionValidator.clearSession();
        }
    } catch (e) {}

    try {
        const keys = [
            'tfx_token', 'tfx_authToken', 'tfx_email', 'tfx_userId', 'tfx_username',
            'tfx_plan', 'tfx_userType', 'tfx_expiresAt', 'tfx_sessionId', 'tfx_paypalSubId',
            'userToken', 'authToken', 'currentUserId', 'userEmail', 'userName',
            'userPlan', 'userType', 'expiresAt', 'stripeCustomerId', 'paypalSubscriptionId', 'userCreatedAt',
            'username'
        ];
        keys.forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    } catch (e) {}

    try {
        if (typeof window !== 'undefined' && window.location) {
            window.location.href = '/auth';
        }
    } catch (e) {}
}

function isDemoMode() {
    try { return typeof window !== 'undefined' && localStorage.getItem('demo_mode') === 'true'; } catch (e) { return false; }
}

// ============================================
// ?? DEMO TURSO CLIENT (localStorage-only)
// ============================================
class DemoTursoClient {
    constructor() {
        this.dbKey = 'demo_db_v1';
    }

    _loadDb() {
        const nowIso = new Date().toISOString();
        const fallbackSeed = {
            version: 1,
            users: [{
                id: 'demo_user',
                email: 'demo@tripulacionfx.com',
                username: 'DEMO',
                user_type: 'user',
                user_plan: 'unlimited',
                expires_at: null,
                created_at: nowIso,
                last_login: nowIso
            }],
            accounts: [{
                id: 'DEMO_ACC_1',
                user_id: 'demo_user',
                name: 'Cuenta Demo',
                type: 'challenge_f1',
                balance: 112.0,
                initial_balance: 100.0,
                status: 'active',
                priority: 'medium',
                is_primary: 1,
                is_archived: 0,
                archived_at: null,
                created_at: nowIso
            }],
            trades: [],
            daily_notes: [],
            payouts: [],
            installations: [],
            cashflows: []
        };
        try {
            const raw = localStorage.getItem(this.dbKey);
            if (raw) return JSON.parse(raw);

            const seed = (typeof window !== 'undefined' && window.DEMO_DB_SEED) ? window.DEMO_DB_SEED : fallbackSeed;
            localStorage.setItem(this.dbKey, JSON.stringify(seed));
            return seed;
        } catch (e) {
            return fallbackSeed;
        }
    }

    _saveDb(db) {
        try { localStorage.setItem(this.dbKey, JSON.stringify(db)); } catch (e) {}
    }

    _normalizeSql(sql) {
        return String(sql || '').replace(/\s+/g, ' ').trim();
    }

    _result(rows) {
        return { rows: Array.isArray(rows) ? rows : [] };
    }

    _genId(prefix) {
        const rand = Math.random().toString(16).slice(2);
        return `${prefix}_${Date.now()}_${rand}`;
    }

    _parseInsert(normalizedSql) {
        const m = normalizedSql.match(/INSERT\s+(?:OR\s+IGNORE\s+)?INTO\s+([a-zA-Z0-9_]+)\s*\(([^)]+)\)\s*VALUES\s*\(([^)]+)\)/i);
        if (!m) return null;
        const table = m[1];
        const columns = m[2].split(',').map(s => s.trim());
        return { table, columns };
    }

    _parseUpdate(normalizedSql) {
        const m = normalizedSql.match(/UPDATE\s+([a-zA-Z0-9_]+)\s+SET\s+(.+?)\s+WHERE\s+(.+)/i);
        if (!m) return null;
        const table = m[1];
        const setPart = m[2];
        const wherePart = m[3];
        const setColumns = setPart.split(',').map(s => s.trim().split('=')[0].trim());
        return { table, setColumns, wherePart };
    }

    async execute({ sql, args = [] }) {
        const db = this._loadDb();
        const q = this._normalizeSql(sql);

        // USERS
        if (q === 'SELECT user_plan FROM users WHERE id = ?') {
            const id = args[0];
            const user = db.users.find(u => u.id === id);
            return this._result(user ? [{ user_plan: user.user_plan || 'free' }] : []);
        }

        if (q === 'SELECT id, email, username, user_type, user_plan, expires_at FROM users WHERE id = ?') {
            const id = args[0];
            const user = db.users.find(u => u.id === id);
            if (!user) return this._result([]);
            return this._result([{ id: user.id, email: user.email, username: user.username, user_type: user.user_type, user_plan: user.user_plan, expires_at: user.expires_at }]);
        }

        if (q === 'SELECT user_type, user_plan FROM users WHERE id = ?') {
            const id = args[0];
            const user = db.users.find(u => u.id === id);
            if (!user) return this._result([]);
            return this._result([{ user_type: user.user_type || 'user', user_plan: user.user_plan || 'free' }]);
        }

        // ACCOUNTS (select)
        if (q.startsWith('SELECT * FROM accounts WHERE user_id = ?') && q.includes('is_archived')) {
            const userId = args[0];
            let rows = db.accounts.filter(a => a.user_id === userId && (!a.is_archived || Number(a.is_archived) === 0));
            if (q.toLowerCase().includes('lower(status) not in')) {
                rows = rows.filter(a => !a.status || (String(a.status).toLowerCase() !== 'archived' && String(a.status).toLowerCase() !== 'archivado'));
            }
            rows = rows.sort((a, b) => String(a.created_at).localeCompare(String(b.created_at)));
            return this._result(rows);
        }

        if (q === 'SELECT * FROM accounts WHERE user_id = ? ORDER BY is_primary DESC, created_at DESC') {
            const userId = args[0];
            const rows = db.accounts
                .filter(a => a.user_id === userId)
                .sort((a, b) => (Number(b.is_primary || 0) - Number(a.is_primary || 0)) || String(b.created_at || '').localeCompare(String(a.created_at || '')));
            return this._result(rows);
        }

        // CASHFLOWS (select)
        if (q === 'SELECT id, type, amount, notes, date, created_at FROM cashflows WHERE user_id = ? AND account_id = ? ORDER BY date ASC, created_at ASC') {
            const userId = args[0];
            const accountId = args[1];
            const rows = db.cashflows
                .filter(c => c.user_id === userId && c.account_id === accountId)
                .sort((a, b) => (String(a.date || '').localeCompare(String(b.date || ''))) || String(a.created_at || '').localeCompare(String(b.created_at || '')));
            return this._result(rows);
        }

        if (q === 'SELECT id, type, amount, notes, date, created_at FROM cashflows WHERE account_id = ? AND date = ? ORDER BY created_at DESC') {
            const accountId = args[0];
            const date = args[1];
            const rows = db.cashflows
                .filter(c => c.account_id === accountId && c.date === date)
                .sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
            return this._result(rows);
        }

        if (q === 'SELECT id FROM accounts WHERE id = ?') {
            const id = args[0];
            const exists = db.accounts.some(a => a.id === id);
            return this._result(exists ? [{ id }] : []);
        }

        // TRADES (select list)
        if (q === 'SELECT * FROM trades WHERE account_id = ? ORDER BY date, timestamp') {
            const accountId = args[0];
            const rows = db.trades
                .filter(t => t.account_id === accountId)
                .sort((a, b) => String(a.date).localeCompare(String(b.date)) || String(a.timestamp || '').localeCompare(String(b.timestamp || '')));
            return this._result(rows);
        }

        // TRADES aggregates for accounts.js
        if (q.includes('FROM trades') && q.includes('WHERE account_id = ?') && q.includes('COUNT(*)') && q.includes('SUM(')) {
            const accountId = args[0];
            const trades = db.trades.filter(t => t.account_id === accountId);
            const total_trades = trades.length;
            const wins = trades.filter(t => Number(t.profit_usd || 0) > 0).length;
            const total_profit_usd = trades.reduce((s, t) => s + Number(t.profit_usd || 0), 0);
            const gross_profit = trades.reduce((s, t) => s + (Number(t.profit_usd || 0) > 0 ? Number(t.profit_usd || 0) : 0), 0);
            const gross_loss = trades.reduce((s, t) => s + (Number(t.profit_usd || 0) < 0 ? Math.abs(Number(t.profit_usd || 0)) : 0), 0);
            const max_loss = trades.reduce((m, t) => {
                const v = Number(t.profit_usd || 0);
                if (v < 0) return Math.max(m, Math.abs(v));
                return m;
            }, 0);
            return this._result([{ total_trades, wins, total_profit_usd, gross_profit, gross_loss, max_loss }]);
        }

        // TRADES count between dates
        if (q === 'SELECT COUNT(*) as count FROM trades WHERE account_id = ? AND date >= ? AND date <= ?') {
            const accountId = args[0];
            const from = args[1];
            const to = args[2];
            const count = db.trades.filter(t => t.account_id === accountId && String(t.date) >= String(from) && String(t.date) <= String(to)).length;
            return this._result([{ count }]);
        }

        // DAILY NOTES (select)
        if (q === 'SELECT date, sentiment, note, day_outcome FROM daily_notes WHERE user_id = ? AND account_id = ? AND date LIKE ?') {
            const userId = args[0];
            const accountId = args[1];
            const like = String(args[2] || '');
            const prefix = like.endsWith('%') ? like.slice(0, -1) : like;
            const rows = db.daily_notes
                .filter(n => n.user_id === userId && n.account_id === accountId && String(n.date).startsWith(prefix))
                .map(n => ({ date: n.date, sentiment: n.sentiment, note: n.note, day_outcome: n.day_outcome }));
            return this._result(rows);
        }

        // INSERT/UPDATE/DELETE (generic-ish)
        const insert = this._parseInsert(q);
        if (insert) {
            const { table, columns } = insert;
            const row = {};
            for (let i = 0; i < columns.length; i++) row[columns[i]] = args[i];

            if (table === 'accounts') {
                if (!row.id) row.id = this._genId('ACC');
                db.accounts.push(row);
                this._saveDb(db);
                return this._result([]);
            }
            if (table === 'trades') {
                if (!row.id) row.id = this._genId('TRD');
                // profit_usd fallback from result if present
                if (row.profit_usd == null && row.result != null) row.profit_usd = row.result;
                db.trades.push(row);
                this._saveDb(db);
                return this._result([]);
            }
            if (table === 'daily_notes') {
                // Enforce uniqueness by (user_id, account_id, date)
                const exists = db.daily_notes.some(n => n.user_id === row.user_id && n.account_id === row.account_id && n.date === row.date);
                if (!exists) {
                    if (!row.id) row.id = this._genId('NOTE');
                    db.daily_notes.push(row);
                    this._saveDb(db);
                }
                return this._result([]);
            }
            if (table === 'payouts') {
                if (!row.id) row.id = this._genId('PAY');
                db.payouts.push(row);
                this._saveDb(db);
                return this._result([]);
            }
            if (table === 'cashflows') {
                if (!row.id) row.id = this._genId('CASH');
                db.cashflows.push(row);
                this._saveDb(db);
                return this._result([]);
            }
        }

        const upd = this._parseUpdate(q);
        if (upd && upd.wherePart) {
            const { table, setColumns, wherePart } = upd;
            // Most updates are WHERE id = ? or WHERE user_id/account_id/date combos.
            if (table === 'accounts' && /WHERE id = \?/i.test(wherePart)) {
                const id = args[setColumns.length];
                const acc = db.accounts.find(a => a.id === id);
                if (acc) {
                    for (let i = 0; i < setColumns.length; i++) acc[setColumns[i]] = args[i];
                    this._saveDb(db);
                }
                return this._result([]);
            }
            if (table === 'daily_notes' && /WHERE user_id = \? AND account_id = \? AND date = \?/i.test(wherePart)) {
                const userId = args[setColumns.length];
                const accountId = args[setColumns.length + 1];
                const date = args[setColumns.length + 2];
                const note = db.daily_notes.find(n => n.user_id === userId && n.account_id === accountId && n.date === date);
                if (note) {
                    for (let i = 0; i < setColumns.length; i++) note[setColumns[i]] = args[i];
                    this._saveDb(db);
                }
                return this._result([]);
            }
            if (table === 'payouts' && /WHERE id = \?/i.test(wherePart)) {
                const id = args[setColumns.length];
                const p = db.payouts.find(x => x.id === id);
                if (p) {
                    for (let i = 0; i < setColumns.length; i++) p[setColumns[i]] = args[i];
                    this._saveDb(db);
                }
                return this._result([]);
            }
        }

        // DELETE
        if (q === 'DELETE FROM trades WHERE id = ?') {
            const id = args[0];
            db.trades = db.trades.filter(t => t.id !== id);
            this._saveDb(db);
            return this._result([]);
        }
        if (q === 'DELETE FROM trades WHERE account_id = ? AND date = ?') {
            const accountId = args[0];
            const date = args[1];
            db.trades = db.trades.filter(t => !(t.account_id === accountId && t.date === date));
            this._saveDb(db);
            return this._result([]);
        }
        if (q === 'DELETE FROM trades WHERE account_id = ?') {
            const accountId = args[0];
            db.trades = db.trades.filter(t => t.account_id !== accountId);
            this._saveDb(db);
            return this._result([]);
        }
        if (q === 'DELETE FROM accounts WHERE id = ?') {
            const id = args[0];
            db.accounts = db.accounts.filter(a => a.id !== id);
            db.trades = db.trades.filter(t => t.account_id !== id);
            this._saveDb(db);
            return this._result([]);
        }
        if (q === 'DELETE FROM trading_plans WHERE account_id = ?') {
            const accountId = args[0];
            db.trading_plans = (db.trading_plans || []).filter(p => p.account_id !== accountId);
            this._saveDb(db);
            return this._result([]);
        }
        if (q === 'DELETE FROM daily_notes WHERE user_id = ? AND account_id = ? AND date = ?') {
            const userId = args[0];
            const accountId = args[1];
            const date = args[2];
            db.daily_notes = db.daily_notes.filter(n => !(n.user_id === userId && n.account_id === accountId && n.date === date));
            this._saveDb(db);
            return this._result([]);
        }
        if (q === 'DELETE FROM payouts WHERE id = ?') {
            const id = args[0];
            db.payouts = db.payouts.filter(p => p.id !== id);
            this._saveDb(db);
            return this._result([]);
        }

        if (q === 'DELETE FROM cashflows WHERE id = ? AND account_id = ?') {
            const id = args[0];
            const accountId = args[1];
            db.cashflows = db.cashflows.filter(c => !(c.id === id && c.account_id === accountId));
            this._saveDb(db);
            return this._result([]);
        }

        // Fallback: return empty rows so UI doesn't crash.
        return this._result([]);
    }
}

export const tursoClient = isDemoMode() ? new DemoTursoClient() : new SecureTursoClient(WORKER_URL);
window.tursoClient = tursoClient;
// Expose worker URL globally for non-module scripts (e.g. app.js)
try { window.WORKER_URL = WORKER_URL; } catch (e) {}

// ============================================
// ?? CLIENTE P�BLICO (sin token) - SOLO LOGIN/REGISTER
// ============================================
async function executePublicQuery({ sql, args = [], adminKey = null }) {
    const body = { sql, args };
    if (adminKey) body.adminKey = adminKey;

    const response = await fetch(`${WORKER_URL}/api/public`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: response.statusText }));
        throw new Error(errorData.error || 'Query failed');
    }

    return await response.json();
}

// ============================================
// ?? GOOGLE reCAPTCHA v3 VALIDATION
// ============================================
// NOTA: Necesitas configurar tu propia RECAPTCHA_SITE_KEY y RECAPTCHA_SECRET_KEY
// Obt�n las claves en: https://www.google.com/recaptcha/admin

const RECAPTCHA_SITE_KEY = '6Lf4ETssAAAAADT1s4Ho72bETMymUeqj6NXLWp4M'; // Reemplazar con tu clave real

// Ejecutar reCAPTCHA en el cliente
async function executeRecaptcha(action = 'submit') {
    try {
        // Verificar si el script de reCAPTCHA est� cargado
        if (typeof grecaptcha === 'undefined') {
            return null;
        }
        
        const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
        return token;
    } catch (error) {
        return null;
    }
}

// Validar token reCAPTCHA en servidor (Cloudflare Worker)
async function validateRecaptchaTokenOnServer(recaptchaToken) {
    try {
        const response = await fetch(`${WORKER_URL}/api/validate-recaptcha`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ token: recaptchaToken })
        });

        const data = await response.json();
        
        return {
            valid: data.valid,
            score: data.score || 0,
            action: data.action,
            error: data.error
        };
    } catch (error) {
        return { valid: false, score: 0, error: error.message };
    }
}

// ============================================
// ?? EMAIL VERIFICATION SYSTEM
// ============================================
// Generar un token de verificaci�n de email
async function generateEmailVerificationToken(userId, email) {
    try {
        const tokenId = generateId();
        const verificationToken = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substr(2);
        const expiresAt = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(); // 24 horas
        
        await executePublicQuery({
            sql: `INSERT INTO email_verification_tokens (id, user_id, token, email, expires_at) 
                  VALUES (?, ?, ?, ?, ?)`,
            args: [tokenId, userId, verificationToken, email, expiresAt]
        });
        
        return verificationToken;
    } catch (error) {
        return null;
    }
}

// Validar un token de verificaci�n de email
async function verifyEmailToken(verificationToken) {
    try {
        const result = await executePublicQuery({
            sql: `SELECT * FROM email_verification_tokens 
                  WHERE token = ? AND is_used = 0 AND expires_at > datetime('now')`,
            args: [verificationToken]
        });
        
        if (result.rows.length === 0) {
            return { success: false, error: 'Token de verificaci�n inv�lido o expirado' };
        }
        
        const tokenData = result.rows[0];
        
        // Marcar como usado
        await executePublicQuery({
            sql: `UPDATE email_verification_tokens SET is_used = 1 WHERE id = ?`,
            args: [tokenData.id]
        });
        
        // Marcar email como verificado en la tabla de usuarios (si es necesario)
        await executePublicQuery({
            sql: `UPDATE users SET email_verified = 1 WHERE id = ?`,
            args: [tokenData.user_id]
        });
        
        return { success: true, userId: tokenData.user_id, email: tokenData.email };
    } catch (error) {
        return { success: false, error: 'Error al verificar email' };
    }
}

// ============================================
// INICIALIZACI�N DE BASE DE DATOS
// ============================================
export async function initializeDatabase() {
    try {
        // Si las migraciones autom�ticas est�n desactivadas, asumir que el esquema est� listo
        if (!ENABLE_AUTO_MIGRATIONS) {
            return true;
        }
        
        // Skip running migrations on every page load if client already ran
        // them for this schema version. This avoids many small network calls
        // (CREATE TABLE / ALTER TABLE) on each reload which can cause slow
        // page loads on the client. Bump DB_SCHEMA_VERSION to force re-run.
        try {
            if (typeof window !== 'undefined' && localStorage.getItem('dbInitVersion') === DB_SCHEMA_VERSION) {
                // Assume DB schema is up-to-date for this client.
                return true;
            }
        } catch (e) { /* ignore storage errors and proceed with migrations */ }
        const tables = [
            `CREATE TABLE IF NOT EXISTS users (
                id TEXT PRIMARY KEY,
                email TEXT UNIQUE NOT NULL,
                username TEXT,
                token TEXT NOT NULL,
                is_active INTEGER DEFAULT 1,
                created_at TEXT DEFAULT CURRENT_TIMESTAMP,
                last_login TEXT,
                expires_at TEXT,
                user_type TEXT DEFAULT 'user',
                user_plan TEXT DEFAULT 'free'
            )`,
            `CREATE TABLE IF NOT EXISTS access_tokens (
                id TEXT PRIMARY KEY,
                token TEXT UNIQUE NOT NULL,
                email TEXT,
                max_uses INTEGER DEFAULT 1,
                uses INTEGER DEFAULT 0,
                is_active INTEGER DEFAULT 1,
                created_at TEXT DEFAULT CURRENT_TIMESTAMP,
                expires_at TEXT,
                notes TEXT
            )`,
            `CREATE TABLE IF NOT EXISTS email_verification_tokens (
                id TEXT PRIMARY KEY,
                user_id TEXT NOT NULL,
                token TEXT UNIQUE NOT NULL,
                email TEXT NOT NULL,
                created_at TEXT DEFAULT CURRENT_TIMESTAMP,
                expires_at TEXT,
                is_used INTEGER DEFAULT 0,
                FOREIGN KEY (user_id) REFERENCES users(id) ON DELETE CASCADE
            )`,
            `CREATE TABLE IF NOT EXISTS accounts (
                id TEXT PRIMARY KEY,
                user_id TEXT NOT NULL,
                name TEXT NOT NULL,
                balance REAL NOT NULL,
                status TEXT DEFAULT 'active',
                type TEXT DEFAULT 'challenge_f1',
                priority TEXT DEFAULT 'medium',
                created_at TEXT DEFAULT CURRENT_TIMESTAMP,
                is_archived INTEGER DEFAULT 0,
                archived_at TEXT,
                FOREIGN KEY (user_id) REFERENCES users(id)
            )`,
            `CREATE TABLE IF NOT EXISTS trades (
                id TEXT PRIMARY KEY,
                account_id TEXT NOT NULL,
                date TEXT NOT NULL,
                pair TEXT NOT NULL,
                direction TEXT NOT NULL,
                risk REAL DEFAULT 0,
                result REAL DEFAULT 0,
                comment TEXT,
                entry_time TEXT,
                exit_time TEXT,
                tradingview_url TEXT,
                timestamp TEXT DEFAULT CURRENT_TIMESTAMP,
                ticket TEXT,
                lot_size REAL,
                entry_price REAL,
                exit_price REAL,
                commission REAL,
                swap REAL,
                profit_usd REAL DEFAULT 0,
                import_source TEXT,
                FOREIGN KEY (account_id) REFERENCES accounts(id) ON DELETE CASCADE
            )`
            ,
            `CREATE TABLE IF NOT EXISTS daily_notes (
                id TEXT PRIMARY KEY,
                user_id TEXT NOT NULL,
                date TEXT NOT NULL,
                sentiment TEXT,
                note TEXT,
                day_outcome TEXT,
                created_at TEXT DEFAULT CURRENT_TIMESTAMP,
                updated_at TEXT DEFAULT CURRENT_TIMESTAMP,
                UNIQUE(user_id, date)
            )`
        ];
        
        for (const tableSql of tables) {
            try {
                await tursoClient.execute({ sql: tableSql, args: [] });
            } catch (e) {}
        }
        
        // Agregar columnas faltantes
        const columnsToAdd = [
            { table: 'users', name: 'expires_at', type: 'TEXT' },
            { table: 'users', name: 'email_verified', type: 'INTEGER DEFAULT 0' },
            { table: 'trades', name: 'ticket', type: 'TEXT' },
            { table: 'trades', name: 'lot_size', type: 'REAL' },
            { table: 'trades', name: 'entry_price', type: 'REAL' },
            { table: 'trades', name: 'exit_price', type: 'REAL' },
            { table: 'trades', name: 'commission', type: 'REAL' },
            { table: 'trades', name: 'swap', type: 'REAL' },
            { table: 'trades', name: 'profit_usd', type: 'REAL DEFAULT 0' },
            { table: 'trades', name: 'import_source', type: 'TEXT' },
            { table: 'trades', name: 'entry_model_id', type: 'TEXT' },  // 🆕 Modelo de entrada asociado
            { table: 'trades', name: 'entry_model_snapshot', type: 'TEXT' },  // 🆕 Snapshot JSON del modelo
            { table: 'accounts', name: 'type', type: 'TEXT DEFAULT "challenge_f1"' },
            { table: 'accounts', name: 'priority', type: 'TEXT DEFAULT "medium"' },
            { table: 'accounts', name: 'syncing', type: 'INTEGER DEFAULT 0' }  // ?? FIX 4: Agregar columna para bloqueo durante sync
        ];
        
        for (const column of columnsToAdd) {
            try {
                await tursoClient.execute({
                    sql: `ALTER TABLE ${column.table} ADD COLUMN ${column.name} ${column.type}`,
                    args: []
                });
            } catch (e) {}
        }
        
        const indexes = [
            'CREATE INDEX IF NOT EXISTS idx_users_email ON users(email)',
            'CREATE INDEX IF NOT EXISTS idx_users_expires ON users(expires_at)',
            'CREATE INDEX IF NOT EXISTS idx_tokens_token ON access_tokens(token)',
            'CREATE INDEX IF NOT EXISTS idx_trades_account_date ON trades(account_id, date)',
            'CREATE INDEX IF NOT EXISTS idx_accounts_user ON accounts(user_id)',
            'CREATE INDEX IF NOT EXISTS idx_trades_ticket ON trades(ticket)',
            'CREATE INDEX IF NOT EXISTS idx_trades_model ON trades(entry_model_id)'  // 🆕 Índice para búsquedas por modelo
        ];
        
        for (const indexSql of indexes) {
            try {
                await tursoClient.execute({ sql: indexSql, args: [] });
            } catch (e) {}
        }

        // Mark migration applied for this client so we don't re-run on every load
        try {
            if (typeof window !== 'undefined' && window.localStorage) {
                localStorage.setItem('dbInitVersion', DB_SCHEMA_VERSION);
            }
        } catch (e) { /* ignore */ }

        return true;
        
    } catch (error) {
        return false;
    }
}






// ============================================
// AUTENTICACI�N - SESI�N EXISTENTE
// ============================================
export async function checkExistingSession() {
    try {
        const email = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail');
        const userId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
        const token = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
        
        // Si falta alguno de estos, no hay sesi�n
        if (!email || !userId || !token) {
            return null;
        }
        
        // Simplemente confiar en lo que est� en localStorage
        return { 
            email: email, 
            username: localStorage.getItem('userName') || email.split('@')[0],
            userId: userId,
            plan: localStorage.getItem('userPlan') || 'free'
        };
        
    } catch (error) {
        return null;
    }
}

// ============================================
// CONSTANTES
// ============================================
export const monthNames = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const dayNames = ['Lun', 'Mar', 'Mi�', 'Jue', 'Vie', 'S�b', 'Dom'];

// ============================================
// FUNCIONES DE UTILIDAD
// ============================================
export function generateId() {
    return Date.now() + Math.random().toString(36).substr(2, 9);
}

// ============================================
// ?? VALIDACI�N DE L�MITE DE CUENTAS
// ============================================
/**
 * Verifica si el usuario puede crear una nueva cuenta seg�n su plan
 * @param {string} userId - ID del usuario
 * @returns {object} { canCreate: boolean, message: string, plan: string, accountCount: number, limit: number }
 */
export async function validateAccountCreation(userId) {
    try {
        // Obtener plan del usuario
        const userResult = await tursoClient.execute({
            sql: 'SELECT user_type, user_plan FROM users WHERE id = ?',
            args: [userId]
        });
        
        if (userResult.rows.length === 0) {
            return { canCreate: false, message: 'Usuario no encontrado' };
        }
        
        const user = userResult.rows[0];
        const userType = user.user_type || 'user';
        const userPlan = (user.user_plan || DEFAULT_PLAN).toLowerCase().trim();
        
        // Admin siempre puede crear cuentas
        if (userType === 'admin') {
            return { 
                canCreate: true, 
                message: 'Admin sin limite de cuentas',
                plan: 'admin',
                accountCount: 0,
                limit: Infinity
            };
        }
        
        // Contar TODAS las cuentas actuales del usuario
        const accountsResult = await tursoClient.execute({
            sql: 'SELECT COUNT(*) as count FROM accounts WHERE user_id = ? AND (is_archived IS NULL OR is_archived = 0)',
            args: [userId]
        });
        
        const accountCount = accountsResult.rows[0]?.count || 0;
        const limit = ACCOUNT_LIMITS[userPlan] || ACCOUNT_LIMITS[DEFAULT_PLAN];
        

        
        // Validar si YA se alcanzo el limite (no permitir crear mas)
        if (accountCount >= limit) {
            return {
                canCreate: false,
                title: 'Limite Alcanzado',
                message: `Has alcanzado el limite de tu plan: ${accountCount}/${limit} cuentas. Actualiza tu plan para crear mas cuentas.`,
                plan: userPlan,
                accountCount,
                limit
            };
        }
        
        return {
            canCreate: true,
            message: `Puedes crear ${limit - accountCount} cuenta(s) mas (${accountCount}/${limit}). Plan: ${userPlan.toUpperCase()}`,
            plan: userPlan,
            accountCount,
            limit
        };
    } catch (error) {

        return { 
            canCreate: false,
            title: 'Error de Validacion',
            message: 'No se pudo validar el limite de cuentas. Por favor intenta de nuevo.'
        };
    }
}

export function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
}

export function formatDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// ============================================
// SISTEMA DE TOASTS ESTILO TRADINGVIEW/NOTION
// ============================================
function initToastStyles() {
    if (document.getElementById('toastStyles')) return;
    
    const style = document.createElement('style');
    style.id = 'toastStyles';
    style.textContent = `
        /* Toast Container */
        .toast-container {
            position: fixed;
            top: 100px;
            right: 24px;
            z-index: 15001;
            display: flex;
            flex-direction: column;
            gap: 12px;
            pointer-events: none;
        }

        /* Individual Toast */
        .toast {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 14px 18px;
            border-radius: 12px;
            background: rgba(20, 22, 26, 0.85);
            backdrop-filter: blur(20px) saturate(180%);
            border: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 
                0 20px 50px rgba(0, 0, 0, 0.4),
                inset 0 1px 0 rgba(255, 255, 255, 0.1);
            color: rgba(255, 255, 255, 0.95);
            font-size: 13px;
            font-weight: 500;
            line-height: 1.5;
            max-width: 380px;
            pointer-events: auto;
            animation: toastSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
            will-change: transform, opacity;
        }

        .toast.toast-exit {
            animation: toastSlideOut 0.25s cubic-bezier(0.7, 0, 0.84, 0) forwards;
        }

        /* Toast Icon */
        .toast-icon {
            flex-shrink: 0;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
        }

        .toast-icon svg {
            width: 20px;
            height: 20px;
            display: block;
        }

        /* Toast Content */
        .toast-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .toast-title {
            font-weight: 600;
            font-size: 13px;
            color: rgba(255, 255, 255, 0.95);
        }

        .toast-message {
            font-weight: 400;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.72);
            line-height: 1.4;
        }

        /* Toast Close Button */
        .toast-close {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            background: transparent;
            border: none;
            color: rgba(255, 255, 255, 0.5);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            margin: -2px -6px 0 0;
            border-radius: 6px;
            transition: all 0.2s ease;
            opacity: 0.6;
        }

        .toast-close:hover {
            background: rgba(255, 255, 255, 0.1);
            color: rgba(255, 255, 255, 0.8);
            opacity: 1;
        }

        /* Toast Type Variants */
        .toast.toast-success {
            border-left: 3px solid #4ade80;
        }

        .toast.toast-error {
            border-left: 3px solid #f87171;
        }

        .toast.toast-warning {
            border-left: 3px solid #fbbf24;
        }

        .toast.toast-info {
            border-left: 3px solid #60a5fa;
        }

        /* Animations */
        @keyframes toastSlideIn {
            from {
                transform: translateX(400px) translateY(-12px);
                opacity: 0;
            }
            to {
                transform: translateX(0) translateY(0);
                opacity: 1;
            }
        }

        @keyframes toastSlideOut {
            from {
                transform: translateX(0) translateY(0);
                opacity: 1;
            }
            to {
                transform: translateX(400px) translateY(-12px);
                opacity: 0;
            }
        }

        /* Responsive */
        @media (max-width: 640px) {
            .toast-container {
                top: 16px;
                right: 12px;
                left: 12px;
                max-width: calc(100vw - 24px);
            }

            .toast {
                max-width: 100%;
                font-size: 12px;
            }
        }
    `;
    document.head.appendChild(style);
}

function getToastContainer() {
    let container = document.querySelector('.toast-container');
    if (!container) {
        container = document.createElement('div');
        container.className = 'toast-container';
        document.body.appendChild(container);
        initToastStyles();
    }
    return container;
}

const toastIcons = {
    success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>',
    error: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
    warning: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3.05h16.94a2 2 0 0 0 1.71-3.05L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>'
};

const toastColors = {
    success: '#4ade80',
    error: '#f87171',
    warning: '#fbbf24',
    info: '#60a5fa'
};

/**
 * NUEVO: Notificaciones modernas SAAS (delegan a notifications.js)
 * Mantiene compatibilidad hacia atr�s con el c�digo existente
 */

// ============================================
// WRAPPERS EXPORTABLES para showAlert, showConfirm, showToast
// Estas funciones delegan a las funciones originales de notifications.js
// Usamos _notifications* para evitar recursion circular
// ============================================

// Exportable wrapper para showAlert
export function showAlert(title, message, type = 'info', duration = 0) {
    // Usar referencia interna para evitar recursion si window.showAlert apunta a este wrapper
    const fn = window._notificationsShowAlert || window.showAlert;
    if (fn && typeof fn === 'function' && fn !== showAlert) {
        return fn(title, message, type, duration);
    }
    // Fallback simple
    return Promise.resolve();
}

// Exportable wrapper para showConfirm
export function showConfirm(titleOrOptions, message, confirmText, cancelText, type) {
    // Usar referencia interna para evitar recursion
    const fn = window._notificationsShowConfirm || window.showConfirm;
    if (fn && typeof fn === 'function' && fn !== showConfirm) {
        return fn(titleOrOptions, message, confirmText, cancelText, type);
    }
    // Fallback simple
    return Promise.resolve(false);
}

// Exportable wrapper para showToast
export function showToast(message, type = 'info', duration = 4000) {
    // Usar referencia interna para evitar recursion
    const fn = window._notificationsShowNotification || window.showNotification;
    if (fn && typeof fn === 'function') {
        return fn(message, type, duration);
    }

    return null;
}

// NO exportamos estas funciones para evitar conflictos
// Solo delegamos a window cuando se necesitan para compatibilidad

// Interno: Toast notification para compatibilidad
function _showToast(message, type = 'info', duration = 4000) {
    if (window.showNotification && typeof window.showNotification === 'function') {
        return window.showNotification(message, type, duration);
    }

    return null;
}

// No exportar showToast, showAlert, showNotification para evitar conflictos
// Las apps deben usar window.showNotification, window.showAlert, etc de notifications.js

// Confirm Modal - NO exportar para evitar conflictos, delegar a window.showConfirm
// export async functionwindow.showConfirm() - DISABLED para evitar recursi�n infinita
// Las apps deben usar window.showConfirm de notifications.js directamente

// ========== FALLBACKS para compatibilidad ==========
function showNotificationFallback(message, type = 'info', duration = 4000) {
    const container = getToastContainer();
    const toast = document.createElement('div');
    const toastId = 'toast-' + Date.now() + Math.random();
    
    toast.id = toastId;
    toast.className = `toast toast-${type}`;
    
    const titleHtml = '';
    const messageHtml = message ? `<div class="toast-message">${message}</div>` : '';

    toast.innerHTML = `
        <div class="toast-icon">${toastIcons[type] || toastIcons.info}</div>
        <div class="toast-content">
            ${titleHtml}
            ${messageHtml}
        </div>
        <button class="toast-close" aria-label="Cerrar notificaci�n" title="Cerrar">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 16px; height: 16px;">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    `;

    container.appendChild(toast);

    const closeBtn = toast.querySelector('.toast-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => removeToast(toastId));
    }

    if (duration > 0) {
        setTimeout(() => removeToast(toastId), duration);
    }

    return toastId;
}

function removeToast(toastId) {
    const toast = document.getElementById(toastId);
    if (toast) {
        toast.classList.add('toast-exit');
        setTimeout(() => toast.remove(), 250);
    }
}

function showConfirmFallback(options) {
    return new Promise((resolve) => {
        const {
            title = 'Estas seguro?',
            message = '',
            confirmText = 'Confirmar',
            cancelText = 'Cancelar',
            type = 'warning',
            icon = ''
        } = options;
        
        const existing = document.getElementById('customConfirm');
        if (existing) existing.remove();
        
        const confirmModal = document.createElement('div');
        confirmModal.id = 'customConfirm';
        confirmModal.className = 'custom-confirm-overlay';
        
        const typeColors = {
            warning: '#f59e0b',
            danger: '#ef4444',
            info: '#3b82f6',
            success: '#22c55e'
        };
        
        confirmModal.innerHTML = `
            <div class="custom-confirm-modal">
                <div class="custom-confirm-icon" style="color: ${typeColors[type]}; font-size: 48px; margin-bottom: 16px;">${icon}</div>
                <h3 class="custom-confirm-title">${title}</h3>
                <p class="custom-confirm-message">${message}</p>
                <div class="custom-confirm-actions">
                    <button class="custom-confirm-cancel">${cancelText}</button>
                    <button class="custom-confirm-confirm" style="background-color: ${typeColors[type]};">${confirmText}</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(confirmModal);
        
        confirmModal.querySelector('.custom-confirm-cancel').addEventListener('click', () => {
            confirmModal.remove();
            resolve(false);
        });
        
        confirmModal.querySelector('.custom-confirm-confirm').addEventListener('click', () => {
            confirmModal.remove();
            resolve(true);
        });
        
        confirmModal.addEventListener('click', (e) => {
            if (e.target === confirmModal) {
                confirmModal.remove();
                resolve(false);
            }
        });
    });
}

// ============================================
// POPUP DE INPUT PERSONALIZADO
// ============================================
export function showPrompt(options) {
    return new Promise((resolve) => {
        const {
            title = 'Ingresa un valor',
            message = '',
            defaultValue = '',
            placeholder = '',
            confirmText = 'Aceptar',
            cancelText = 'Cancelar',
            type = 'text', // text, email, number
            required = false
        } = options;
        
        const existing = document.getElementById('customPrompt');
        if (existing) existing.remove();

        // strip leading common emoji from title/message to avoid duplicate icons
        const knownLeading = [];
        let cleanTitle = title;
        let cleanMessage = message;
        
        const promptModal = document.createElement('div');
        promptModal.id = 'customPrompt';
        promptModal.className = 'custom-confirm-overlay';
        
        promptModal.innerHTML = `
            <div class="custom-confirm-modal">
                <div class="confirm-icon" style="color: ${type === 'password' ? '#f59e0b' : '#3b82f6'}">
                    ${type === 'password' ? '' : ''}
                </div>
                <h3 class="confirm-title">${cleanTitle}</h3>
                ${cleanMessage ? `<p class="confirm-message">${cleanMessage}</p>` : ''}
                <input 
                    type="${type}" 
                    class="prompt-input" 
                    placeholder="${placeholder}"
                    value="${defaultValue}"
                    ${required ? 'required' : ''}
                >
                <div class="confirm-actions">
                    <button class="confirm-btn confirm-cancel">${cancelText}</button>
                    <button class="confirm-btn confirm-accept ${type === 'password' ? 'warning' : 'info'}">${confirmText}</button>
                </div>
            </div>
        `;
        
        // Agregar estilos del input
        if (!document.getElementById('promptInputStyles')) {
            const style = document.createElement('style');
            style.id = 'promptInputStyles';
            style.textContent = `
                .prompt-input {
                    width: 100%;
                    padding: 12px 16px;
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 8px;
                    color: white;
                    font-size: 16px;
                    margin-bottom: 20px;
                    transition: all 0.2s;
                }
                
                .prompt-input:focus {
                    outline: none;
                    border-color: #3b82f6;
                    background: rgba(255, 255, 255, 0.08);
                }
                
                .prompt-input::placeholder {
                    color: #546e7a;
                }
            `;
            document.head.appendChild(style);
        }
        
        document.body.appendChild(promptModal);
        // Behave like other modals so centering/z-index/close semantics match
        try {
            promptModal.classList.add('show');
            promptModal.style.display = 'flex';
            promptModal.setAttribute('aria-hidden', 'false');
        } catch (e) {}

        const input = promptModal.querySelector('.prompt-input');
        const cancelBtn = promptModal.querySelector('.confirm-cancel');
        const acceptBtn = promptModal.querySelector('.confirm-accept');
        
        // Focus en el input
        setTimeout(() => input.focus(), 100);
        
        const close = (result) => {
            try { promptModal.classList.remove('show'); } catch (e) {}
            try { promptModal.style.animation = 'fadeOut 0.2s ease'; } catch (e) {}
            try { promptModal.style.display = 'none'; } catch (e) {}
            try { promptModal.setAttribute('aria-hidden', 'true'); } catch (e) {}
            setTimeout(() => {
                try { promptModal.remove(); } catch (e) {}
                resolve(result);
            }, 200);
        };
        
        cancelBtn.onclick = () => close(null);
        acceptBtn.onclick = () => {
            if (required && !input.value.trim()) {
                input.style.borderColor = '#ef4444';
                input.focus();
                return;
            }
            close(input.value);
        };
        
        input.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                acceptBtn.click();
            }
        });
        
        promptModal.onclick = (e) => {
            if (e.target === promptModal) close(null);
        };
    });
}

// ============================================
// FUNCIONES DE NAVEGACI�N GLOBALES
// ============================================
export function goToHome() {
    window.location.href = '/';
}

export function goToJournal() {
    window.location.href = '/journal';
}

export function goToAccounts() {
    window.location.href = '/gestion';
}

export function showUserInfo() {
    const email = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail');
    const username = localStorage.getItem('userName');
    const expiresAt = localStorage.getItem('accountExpires');
    const userPlan = localStorage.getItem('userPlan') || 'free';
    const userType = localStorage.getItem('userType') || 'user';
    const dbUserType = sessionStorage.getItem('dbUserType') || 'user';
    const userId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
    
    let display = 'Usuario';
    if (username) display = username;
    else if (email) display = email.split('@')[0];

    try {
        const modal = document.getElementById('userInfoModal');
        const nameEl = document.getElementById('userInfoName');
        const emailEl = document.getElementById('userInfoEmail');
        const accountsEl = document.getElementById('userInfoAccounts');
        const expiresEl = document.getElementById('userInfoExpires');
        const statusEl = document.getElementById('userInfoStatus');
        const statusDotEl = document.getElementById('userInfoStatusDot');
        const planEl = document.getElementById('userInfoPlan');
        const planLimitEl = document.getElementById('userInfoPlanLimit');
        const typeEl = document.getElementById('userInfoType');

        // Configurar nombre y email
        if (nameEl) nameEl.textContent = display.toUpperCase();
        if (emailEl) emailEl.textContent = email || '-';
        
        // Configurar n�mero de cuentas (desde BD o desde window.accounts)
        if (accountsEl) {
            // Intentar primero desde window.accounts (journal.html con app.js)
            let totalAccounts = (window.accounts && typeof window.accounts === 'object') ? Object.keys(window.accounts).length : null;
            
            // Si no est� disponible, consultar la BD (gestion)
            if (totalAccounts === null && userId) {
                tursoClient.execute({
                    sql: 'SELECT COUNT(*) as count FROM accounts WHERE user_id = ?',
                    args: [userId]
                }).then(result => {
                    const count = result.rows[0]?.count || 0;
                    accountsEl.textContent = `${count} cuenta${count !== 1 ? 's' : ''}`;
                }).catch(error => {
                    accountsEl.textContent = '--';
                });
            } else if (totalAccounts !== null) {
                accountsEl.textContent = `${totalAccounts} cuenta${totalAccounts !== 1 ? 's' : ''}`;
            } else {
                accountsEl.textContent = '--';
            }
        }
        
        // Configurar tipo de usuario (solo mostrar si es admin)
        if (typeEl) {
            const isAdmin = userType === 'admin' || dbUserType === 'admin';
            if (isAdmin) {
                typeEl.textContent = 'Admin';
                typeEl.parentElement.style.display = 'block';
            } else {
                typeEl.parentElement.style.display = 'none';
            }
        }
        
        // Configurar plan
        if (planEl) {
            const planNames = {
                'free': 'Free',
                'pro': 'Pro',
                'unlimited': 'Unlimited'
            };
            planEl.textContent = planNames[userPlan] || userPlan.toUpperCase();
        }
        
        if (planLimitEl) {
            const planLimits = {
                'free': 'max: 2 cuentas',
                'pro': 'max: 6 cuentas',
                'unlimited': 'sin limite'
            };
            planLimitEl.textContent = planLimits[userPlan] || '-';
        }
        
        // Estado de la cuenta y fecha de expiracion
        if (expiresAt) {
            const expireDate = new Date(expiresAt);
            const now = new Date();
            const daysLeft = Math.ceil((expireDate - now) / (1000 * 60 * 60 * 24));
            
            if (daysLeft > 0) {
                if (expiresEl) expiresEl.textContent = `Expira en ${daysLeft} dias`;
                if (statusEl) {
                    statusEl.textContent = 'Activa';
                    statusEl.style.color = '#4caf50';
                }
                if (statusDotEl) {
                    statusDotEl.style.background = '#4caf50';
                    statusDotEl.style.boxShadow = '0 0 12px #4caf50';
                }
            } else if (daysLeft <= 0 && daysLeft > -30) {
                if (expiresEl) {
                    expiresEl.textContent = 'Por Expirar';
                    expiresEl.className = 'stat-value days-warning';
                }
                if (statusEl) {
                    statusEl.textContent = 'Por Expirar';
                    statusEl.style.color = '#ff9800';
                }
                if (statusDotEl) {
                    statusDotEl.style.background = '#ff9800';
                    statusDotEl.style.boxShadow = '0 0 12px #ff9800';
                }
            } else if (daysLeft <= -30) {
                if (expiresEl) {
                    expiresEl.textContent = 'Expirada';
                    expiresEl.className = 'stat-value days-danger';
                }
                if (statusEl) {
                    statusEl.textContent = 'Inactiva';
                    statusEl.style.color = '#f44336';
                }
                if (statusDotEl) {
                    statusDotEl.style.background = '#f44336';
                    statusDotEl.style.boxShadow = '0 0 12px #f44336';
                }
            }
        } else {
            // Sin fecha de expiracion - plan ilimitado
            if (expiresEl) expiresEl.textContent = 'Sin limite';
            if (statusEl) {
                statusEl.textContent = 'Activa';
                statusEl.style.color = '#4caf50';
            }
            if (statusDotEl) {
                statusDotEl.style.background = '#4caf50';
                statusDotEl.style.boxShadow = '0 0 12px #4caf50';
            }
        }

        // Button visibility logic for new action bar
        const planLower = userPlan.toLowerCase();
        const isAdmin = userType === 'admin';
        const hasPaidPlan = planLower === 'pro' || planLower === 'unlimited';
        const paypalSubscriptionId = localStorage.getItem('paypalSubscriptionId') || localStorage.getItem('tfx_paypalSubId');
        const hasPayPalSubscription = !!paypalSubscriptionId && paypalSubscriptionId.trim().length > 0;

        // 1. Cancel Subscription Button (Facturación) - PRO/UNLIMITED ONLY AND must have PayPal subscription
        const cancelSubBtn = document.getElementById('cancelSubscriptionBtn');
        if (cancelSubBtn) {
            // Only show if has paid plan AND has a PayPal subscription
            cancelSubBtn.style.display = (hasPaidPlan && hasPayPalSubscription) ? 'block' : 'none';
        }

        // 2. Upgrade Plan Button (Mejorar) - FREE/PRO only (not UNLIMITED)
        const upgradePlanBtn = document.getElementById('upgradePlanBtn');
        if (upgradePlanBtn) {
            const canUpgrade = planLower === 'free' || planLower === 'pro';
            upgradePlanBtn.style.display = canUpgrade ? 'block' : 'none';
        }

        // 3. Admin Access Button (Admin) - admins only
        const adminAccessBtn = document.getElementById('adminAccessBtn');
        if (adminAccessBtn) {
            adminAccessBtn.style.display = isAdmin ? 'block' : 'none';
        }

        // Conditional stat items
        // Show Trades/mes only for FREE plan
        const tradesAllowedItem = document.getElementById('tradesAllowedItem');
        const tradesAllowedEl = document.getElementById('userInfoTradesAllowed');
        if (tradesAllowedItem) {
            if (planLower === 'free') {
                // Count trades for current month
                let monthlyTradeCount = 0;
                if (window.journalData && typeof window.journalData === 'object') {
                    const now = new Date();
                    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                    const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                    
                    for (let d = new Date(monthStart); d <= monthEnd; d.setDate(d.getDate() + 1)) {
                        const dateKey = formatDateKey(d);
                        const dayTrades = window.journalData[dateKey] || [];
                        monthlyTradeCount += dayTrades.length;
                    }
                }
                
                tradesAllowedItem.style.display = 'block';
                if (tradesAllowedEl) {
                    tradesAllowedEl.textContent = `${monthlyTradeCount}/20`;
                }
            } else {
                tradesAllowedItem.style.display = 'none';
            }
        }

        // Show Tipo (admin indicator) only for admins
        const typeItem = document.getElementById('typeItem');
        const typeValueEl = document.getElementById('userInfoType');
        if (typeItem) {
            if (isAdmin) {
                typeItem.style.display = 'block';
                typeItem.classList.remove('hidden');
                if (typeValueEl) {
                    typeValueEl.textContent = userType || dbUserType || '-';
                }
            } else {
                typeItem.style.display = 'none';
                typeItem.classList.add('hidden');
            }
        }
    } catch (e) {
       window.showAlert('Información de Usuario', `Usuario: ${display}`, 'info');
    }
}

export function closeUserInfoModal() {
    try {
        const modal = document.getElementById('userInfoModal');
        if (modal) {
            modal.classList.remove('show');
            modal.classList.add('hidden');
            modal.style.display = 'none';
            modal.classList.remove('user-panel');
            modal.setAttribute('aria-hidden', 'true');
        }
    } catch (e) {}
}

// ?? FUNCIONES PARA CAMBIAR CONTRASE�A
export function showChangePasswordForm() {
    const form = document.getElementById('changePasswordForm');
    const section = document.getElementById('changePasswordSection');
    
    if (section) {
        section.classList.remove('hidden');
        section.style.display = 'block';
        if (form) form.reset();
    }
}

export function hideChangePasswordForm() {
    const section = document.getElementById('changePasswordSection');
    if (section) {
        section.classList.add('hidden');
        section.style.display = 'none';
    }
}

export async function handleChangePassword() {
    const form = document.getElementById('changePasswordForm');
    if (!form) return;
    
    const currentPassword = document.getElementById('currentPassword').value;
    const newPassword = document.getElementById('newPassword').value;
    const confirmPassword = document.getElementById('confirmPassword').value;
    const userId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
    
    // Validaciones
    if (!currentPassword || !newPassword || !confirmPassword) {
        if (window.showAlert) {
            window.showAlert('Campos Incompletos', 'Por favor completa todos los campos', 'warning');
        }
        return;
    }
    
    if (newPassword.length < 8) {
        if (window.showAlert) {
            window.showAlert('Contrasena Invalida', 'Nueva contrasena debe tener minimo 8 caracteres', 'warning');
        }
        return;
    }
    
    if (newPassword !== confirmPassword) {
        if (window.showAlert) {
            window.showAlert('Error de Verificacion', 'Las contrasenas no coinciden', 'warning');
        }
        return;
    }
    
    if (newPassword === currentPassword) {
        if (window.showAlert) {
            window.showAlert('Contrasena Invalida', 'La nueva contrasena debe ser diferente a la actual', 'warning');
        }
        return;
    }
    
    try {
        const baseUrl = (typeof window !== 'undefined' && window.WORKER_URL)
            ? window.WORKER_URL
            : 'https://trading-journal-preprod.monkeydfx-trader.workers.dev';
        const response = await fetch(`${baseUrl}/api/change-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                userId,
                currentPassword,
                newPassword
            })
        });
        
        const data = await response.json();
        
        if (!response.ok) {
            if (window.showAlert) {
                window.showAlert('Error', data.error, 'error');
            }
            return;
        }
        
        if (window.showAlert) {
            window.showAlert('Cambio Exitoso', 'Contrasena actualizada correctamente', 'success');
        }
        
        // Limpiar formulario
        form.reset();
        hideChangePasswordForm();
        
    } catch (error) {
        if (window.showAlert) {
            window.showAlert('Error', 'Ocurrio un error. Por favor intenta de nuevo.', 'error');
        }
    }
}

export async function showAdminPanel({ force = false } = {}) {
    // ?? GUARD #0: Si la app a�n no est� inicializada, NUNCA mostrar modal de admin
    // Esto previene que se muestre durante el bootstrap de la p�gina
    if (!window._appInitialized) {
        if (!force) {
            // Normal case - esperar a que se inicialice
            return;
        }
        // force=true solo se usa internamente cuando sabemos que es seguro
    }
    
    // ?? GUARD #1: Si el modal de admin no existe en esta p�gina, retornar sin error
    const modal = document.getElementById('adminModal');
    if (!modal) {
        // Esta p�gina no tiene el panel admin (como accounts-v2.html)
        return;
    }

    try {
        // ?? GUARD #2: First verify if user has admin privileges.
        // Accept any of: localStorage flag (legacy), sessionStorage DB flag (safer), or an in-memory admin token.
        const userTypeLocal = localStorage.getItem('userType');
        const isSessionAdmin = (typeof window !== 'undefined' && sessionStorage.getItem('dbUserType') === 'admin');
        const hasToken = (typeof window !== 'undefined' && !!window._adminToken);
        
        // ?? CRITICAL: Si NO es admin por NINGUNO de los tres canales, RECHAZAR
        if (userTypeLocal !== 'admin' && !isSessionAdmin && !hasToken) {
           window.showAlert('Acceso Denegado', 'No tienes permisos de administrador', 'error');
            return;
        }
    } catch (e) {
       window.showAlert('Acceso Denegado', 'No tienes permisos de administrador', 'error');
        return;
    }

    try {
        // Try to use cached admin token first
        let verified = false;
        if (window._adminToken) {
            try {
                const verifyBase = (typeof window !== 'undefined' && window.WORKER_URL) ? window.WORKER_URL : WORKER_URL;
                const checkResponse = await fetch(`${verifyBase}/api/admin-verify`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${window._adminToken}`
                    }
                });
                if (checkResponse.ok) {
                    const checkData = await checkResponse.json();
                    if (checkData.success) {
                        verified = true;
                    }
                }
            } catch (e) {
                // Ignore error and continue to password prompt
                delete window._adminToken;
            }
        }

        if (!verified) {
            // Show password modal with centered input
            const password = await window.showConfirm({
                title: '?? Verificaci�n Admin',
                message: `
                    <div style="text-align:center;margin:20px 0;">
                        <input 
                            type="password" 
                            id="adminPasswordInput" 
                            class="prompt-input" 
                            placeholder="Contrase�a admin" 
                            style="
                                position: relative;
                                width: 100%;
                                padding: 12px 16px;
                                background: rgba(255, 255, 255, 0.05);
                                border: 1px solid rgba(255, 255, 255, 0.2);
                                border-radius: 8px;
                                color: white;
                                font-size: 16px;
                                margin: 10px auto;
                                transition: all 0.2s;
                                box-sizing: border-box;
                            "
                        />
                    </div>
                `,
                type: 'warning',
                icon: '??',
                confirmText: 'Verificar',
                cancelText: 'Cancelar'
            }).then(confirmed => {
                if (!confirmed) return null;
                const input = document.getElementById('adminPasswordInput');
                return input ? input.value : null;
            });

            if (!password) return;

            if (!password || !password.trim()) {
               window.showAlert('Campo Requerido', 'Debes ingresar una contrasena', 'error');
                return;
            }

            // Prefer global worker URL (set by config.js or environment), fallback to module constant
            const verifyBase = (typeof window !== 'undefined' && window.WORKER_URL) ? window.WORKER_URL : WORKER_URL;

            // Ask worker to log us in and return a short-lived token
            const loginResp = await fetch(`${verifyBase}/api/admin-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password })
            });

            const loginData = await loginResp.json().catch(() => ({}));
            if (!loginResp.ok || !loginData.token) {
                const error = loginData.error || 'Contrasena incorrecta';
               window.showAlert('Error de Autenticacion', error, 'error');
                return;
            }

            // Store token in memory for the current page session
            window._adminToken = loginData.token;
            verified = true;
        }

        // If we got here, authentication succeeded
        // Safety: only auto-open the modal if the user has interacted recently
        try {
            const last = (window && window._lastUserActivity) ? Number(window._lastUserActivity) : 0;
            const idleMs = Date.now() - last;
            // If caller did not force open and user activity is stale (>3s), avoid auto-opening
            if (!force && idleMs > 3000) {
                // Let the user click the Admin button explicitly instead of popping the modal
                try { if (window.showAlert) window.showAlert('Verificacion Exitosa', 'Haz clic en Admin para abrir el panel', 'info', 4000); }
                catch (e) {}
                return;
            }
        } catch (e) { /* ignore */ }

        // Show admin modal if it exists
        const modal = document.getElementById('adminModal');
        if (modal) {
            // Make modal visible both via class (for animations) and explicit display
            modal.classList.add('show');
            modal.style.display = 'flex';
            modal.setAttribute('aria-hidden', 'false');
           window.showAlert('Acceso Concedido', 'Verificacion exitosa', 'success');
        } else {
           window.showAlert('Panel No Disponible', 'Verificacion exitosa, pero no se encontro el panel admin en esta pagina', 'info');
        }

    } catch (error) {
        delete window._adminToken; // Clear any failed token
       window.showAlert('Error', window.getSafeErrorMessage(error), 'error');
    }
}
/**
 * ? CREAR TOKEN DE ACCESO CON EXPIRACI�N
 * Esta funci�n llama al endpoint /api/admin del worker
 */
export async function createAccessToken({ email, username, expiresAt = null, maxUses = 1, notes = '' }) {
    if (!email) {
       window.showAlert('Campo Requerido', 'Email es obligatorio', 'error');
        throw new Error('Email requerido');
    }

    const id = generateId();
    
    try {
        // If we don't have a cached admin token, prompt for password and login
        if (!window._adminToken) {
            const adminSecret = await showPrompt({
                title: 'Autenticacion Admin',
                message: 'Introduce la contrasena administrativa:',
                type: 'password',
                placeholder: 'Contrasena',
                required: true
            });

            if (!adminSecret) {
               window.showAlert('Campo Requerido', 'Admin secret requerido', 'warning');
                throw new Error('Admin secret required');
            }

            const verifyBase = (typeof window !== 'undefined' && window.WORKER_URL) ? window.WORKER_URL : WORKER_URL;
            const loginResp = await fetch(`${verifyBase}/api/admin-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password: adminSecret })
            });

            const loginData = await loginResp.json().catch(() => ({}));
            if (!loginResp.ok || !loginData.token) {
                const msg = loginData.error || 'Contrasena incorrecta';
               window.showAlert('Error de Autenticacion', msg, 'error');
                throw new Error(msg);
            }

            window._adminToken = loginData.token; // Guardar para proximas operaciones
        }

        const body = {
            email,
            username: username || null,
            expiresAt: expiresAt || null,
            maxUses: Number(maxUses) || 1,
            notes: notes || null
        };

        const base = (typeof window !== 'undefined' && window.WORKER_URL) ? window.WORKER_URL : WORKER_URL;
        const resp = await fetch(`${base}/api/admin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${window._adminToken}`
            },
            body: JSON.stringify(body)
        });

        const data = await resp.json().catch(() => ({}));
        
        if (!resp.ok) {
            const msg = data?.error || `HTTP ${resp.status}`;
            
            if (resp.status === 403) {
               window.showAlert('Contrasena Incorrecta', 'Contrasena de administrador incorrecta', 'error');
                delete window._adminToken; // Limpiar token incorrecto
            } else {
               window.showAlert('Error', 'Error: ' + msg, 'error');
            }
            
            throw new Error(msg);
        }

        if (!data || !data.token) {
           window.showAlert('Error del Servidor', 'No se recibi� token del servidor', 'error');
            throw new Error('No token returned from admin endpoint');
        }

        return data.token;
    } catch (error) {
        if (!error.message.includes('Admin secret')) {
           window.showAlert('Error al Crear Token', 'No se pudo crear el token. Por favor intenta de nuevo.', 'error');
        }
        
        throw error;
    }
}

// ============================================
// ?? RENOVAR/EXTENDER CUENTA DE USUARIO EXPIRADA
// ============================================
/**
 * Renueva la expiraci�n de una cuenta de usuario (admin panel)
 * Actualiza:
 * - users.expires_at (fecha de acceso al usuario)
 * - users.is_active (reactivar si estaba inactivo)
 * - access_tokens relacionados (si existen)
 * 
 * @param {string} userId - ID del usuario a renovar
 * @param {number} daysToAdd - D�as a agregar (7, 15, 30, etc)
 * @returns {object} { success: boolean, message: string, newExpiresAt: string }
 */
export async function renewUserAccount(userId, daysToAdd = 30) {
    if (!userId || !daysToAdd) {
       window.showAlert('Parametros Invalidos', 'Parametros invalidos', 'error');
        return { success: false };
    }

    try {
        // Calcular nueva fecha de expiraci�n
        const newExpiresAt = new Date();
        newExpiresAt.setDate(newExpiresAt.getDate() + daysToAdd);
        const expiresAtISO = newExpiresAt.toISOString();

        // 1?? Renovar usuario
        await tursoClient.execute({
            sql: `UPDATE users SET expires_at = ?, is_active = 1 WHERE id = ?`,
            args: [expiresAtISO, userId]
        });

        // 2?? Renovar tokens de acceso asociados (si existen y est�n expirados)
        // Solo renovar tokens que fueron usados para registrarse (tienen email del usuario)
        try {
            const userResult = await tursoClient.execute({
                sql: 'SELECT email FROM users WHERE id = ?',
                args: [userId]
            });

            if (userResult.rows.length > 0) {
                const userEmail = userResult.rows[0].email;
                
                // Reactivar tokens inactivos del usuario
                await tursoClient.execute({
                    sql: `UPDATE access_tokens SET expires_at = ?, is_active = 1, uses = 0 
                          WHERE email = ? AND is_active = 0`,
                    args: [expiresAtISO, userEmail]
                });
            }
        } catch (tokenError) {
        }

       window.showAlert('Cuenta Renovada', `Cuenta renovada por ${daysToAdd} dias`, 'success');
        
        return {
            success: true,
            message: `Cuenta renovada hasta ${newExpiresAt.toLocaleDateString('es-ES')}`,
            newExpiresAt: expiresAtISO
        };
    } catch (error) {
       window.showAlert('Error al Renovar', 'No se pudo renovar la cuenta. Por favor intenta de nuevo.', 'error');
        return { success: false, message: error.message };
    }
}

// ============================================
// ??? GESTIONAR TOKENS DE ACCESO
// ============================================
/**
 * Renovar un token de acceso espec�fico
 * @param {string} email - Email asociado al token
 * @param {number} daysToAdd - D�as a agregar
 * @param {number} newMaxUses - Nuevo m�ximo de usos (opcional)
 */
export async function renewAccessToken(email, daysToAdd = 30, newMaxUses = null) {
    if (!email) {
       window.showAlert('Email Requerido', 'Email requerido', 'error');
        return { success: false };
    }

    try {
        const newExpiresAt = new Date();
        newExpiresAt.setDate(newExpiresAt.getDate() + daysToAdd);
        const expiresAtISO = newExpiresAt.toISOString();

        let updateSQL = `UPDATE access_tokens SET expires_at = ?, is_active = 1, uses = 0`;
        let args = [expiresAtISO, email];

        // Si se especifica nuevo m�ximo de usos
        if (newMaxUses !== null && newMaxUses > 0) {
            updateSQL += `, max_uses = ?`;
            args = [expiresAtISO, newMaxUses, email];
        }

        updateSQL += ` WHERE email = ?`;

        await tursoClient.execute({
            sql: updateSQL,
            args: args
        });

       window.showAlert('Token Renovado', `Token renovado por ${daysToAdd} dias`, 'success');
        return {
            success: true,
            message: `Token renovado hasta ${newExpiresAt.toLocaleDateString('es-ES')}`
        };
    } catch (error) {
       window.showAlert('Error al Renovar Token', 'No se pudo renovar el token. Por favor intenta de nuevo.', 'error');
        return { success: false, message: error.message };
    }
}

// ============================================
// ?? BUSCAR USUARIO POR EMAIL (ADMIN)
// ============================================
export async function searchUserByEmail(email) {
    if (!email || email.trim() === '') {
        return { success: false, error: 'Email requerido' };
    }

    try {
        const result = await tursoClient.execute({
            sql: `SELECT id, email, expires_at, is_active, user_plan FROM users WHERE LOWER(email) = LOWER(?)`,
            args: [email.trim()]
        });

        if (result.rows && result.rows.length > 0) {
            const user = result.rows[0];
            return {
                success: true,
                user: {
                    id: user.id,
                    email: user.email,
                    expires_at: user.expires_at,
                    is_active: user.is_active,
                    user_plan: user.user_plan || 'free'
                }
            };
        }

        return { success: false, error: 'Usuario no encontrado' };
    } catch (error) {
        return { success: false, error: error.message };
    }
}

// ?? Ir a los planes del dashboard
export function goToPlans() {
    // Guardar flag para que inicio sepa que debe scrollear a planes
    try { sessionStorage.setItem('scrollToPlans', 'true'); } catch (e) {}
    
    // Navegar a la página principal
    const baseUrl = window.location.origin;
    window.location.href = baseUrl + '/';
}

export async function logoutUser() {
    const confirmed = await window.showConfirm({
        title: 'Cerrar Sesion',
        message: 'Estas seguro de que quieres cerrar sesion?',
        confirmText: 'Cerrar Sesion',
        cancelText: 'Cancelar',
        type: 'warning'
    });
    
    // SOLO cerrar sesion si el usuario confirmo
    if (confirmed) {
        // FIX: Marcar como logout voluntario PRIMERO, antes de clearSession()
        // para que clearSession() sepa que no debe setear _sessionExpired
        localStorage.setItem('_logoutVoluntario', 'true');
        
        try {
            if (window.SessionValidator && typeof window.SessionValidator.clearSession === 'function') {
                window.SessionValidator.clearSession();
            } else if (typeof SessionValidator !== 'undefined' && typeof SessionValidator.clearSession === 'function') {
                SessionValidator.clearSession();
            } else {
                // Fallback minimal cleanup
                try { sessionStorage.clear(); } catch (e) {}
                try { localStorage.removeItem('userToken'); } catch (e) {}
                try { localStorage.removeItem('authToken'); } catch (e) {}
                try { localStorage.removeItem('currentUserId'); } catch (e) {}
                try { localStorage.removeItem('tfx_token'); } catch (e) {}
                try { localStorage.removeItem('tfx_authToken'); } catch (e) {}
                try { localStorage.removeItem('tfx_userId'); } catch (e) {}
            }
        } catch (e) {}
        try { delete window._adminToken; } catch (e) {}
        
        setTimeout(() => {
            window.location.href = '/';
        }, 500); // Reducir delay porque no hay notificación
    }
    // Si confirmed es false, no hace nada (cancela la acci�n)
}

/**
 * Forzar cierre de sesi�n (sin confirmaci�n). Limpia estado local y redirige.
 * Usado por el mecanismo de timeout autom�tico para garantizar un logout consistente.
 */
export async function forceLogout() {
    try {
        // Clear client-side session data
        try {
            if (window.SessionValidator && typeof window.SessionValidator.clearSession === 'function') {
                window.SessionValidator.clearSession();
            } else if (typeof SessionValidator !== 'undefined' && typeof SessionValidator.clearSession === 'function') {
                SessionValidator.clearSession();
            }
        } catch (e) {}
        try { sessionStorage.clear(); } catch (e) {}
        try { localStorage.removeItem('username'); } catch (e) {}
        try { sessionStorage.removeItem('dbUserType'); } catch (e) {}
        try { delete window._adminToken; } catch (e) {}

        // Close common modals/overlays to avoid stuck UI
        try {
            ['adminModal','adminAuthModal','userInfoModal','authModal'].forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    el.classList.remove('show');
                    try { el.style.display = 'none'; } catch (e) {}
                    el.setAttribute('aria-hidden', 'true');
                }
            });
            // remove any custom overlays
            document.querySelectorAll('.custom-confirm-overlay, #customConfirm, #customPrompt').forEach(el => el.remove());
        } catch (e) { /* ignore */ }

        try {
            // FIX: No mostrar notificación si fue logout voluntario
            const wasVoluntaryLogout = localStorage.getItem('_logoutVoluntario') === 'true';
            if (window.showAlert && typeof window.showAlert === 'function' && !wasVoluntaryLogout) {
                window.showAlert('Sesión finalizada', 'Tu sesión terminó por inactividad. Inicia sesión de nuevo.', 'info');
            }
        } catch (e) {}

        setTimeout(() => {
            try { window.location.href = '/'; } catch (e) {}
        }, 1000);
    } catch (err) {
        try { localStorage.clear(); } catch (e) {}
        try { window.location.href = '/'; } catch (e) {}
    }
}

// ============================================
// SESSION TIMEOUT - INACTIVIDAD 15 MINUTOS
// ============================================
let sessionTimeoutTimer = null;
let inactivityTimer = null;
const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutos

export function initSessionTimeout() {
    const resetTimeout = () => {
        // Limpiar timer anterior
        if (inactivityTimer) clearTimeout(inactivityTimer);
        
        // Configurar nuevo timer
        inactivityTimer = setTimeout(() => {
            // Si llega aquí, pasaron 15 minutos sin actividad
            try {
                const isDemo = (window.SessionValidator && typeof window.SessionValidator.isDemoSession === 'function')
                    ? window.SessionValidator.isDemoSession()
                    : (localStorage.getItem('demo_mode') === 'true');
                if (isDemo) return;

                const hasToken = (window.SessionValidator && typeof window.SessionValidator.getToken === 'function')
                    ? !!window.SessionValidator.getToken()
                    : !!(sessionStorage.getItem('tfx_token') || sessionStorage.getItem('tfx_authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('tfx_token') || localStorage.getItem('tfx_authToken') || localStorage.getItem('authToken'));

                if (hasToken) {
                    forceLogout();
                }
            } catch (e) {
                forceLogout();
            }
        }, SESSION_TIMEOUT);
    };
    
    // Eventos que resetean el timeout
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
        document.addEventListener(event, resetTimeout, { passive: true });
    });
    
    // Iniciar el timer
    resetTimeout();
}

// ============================================
// HELPER: MOSTRAR ADVERTENCIA DE EXPIRACI�N
// ============================================
export function showExpirationWarning() {
    // ? NO mostrar en el dashboard
    const isDashboard = window.location.pathname === '/' || 
                       window.location.pathname.includes('index') ||
                       window.location.pathname.includes('dashboard');
    if (isDashboard) return;
    
    // ? Verificar que hay datos de expiraci�n
    const expiresAt = localStorage.getItem('accountExpires');
    if (!expiresAt) return;
    
    const expirationDate = new Date(expiresAt);
    const now = new Date();
    const daysLeft = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
    
    // Solo mostrar si quedan 7 días o menos
    if (daysLeft <= 7 && daysLeft > 0) {
        const notifKey = `expirationWarningShown_${expiresAt}`;
        if (!sessionStorage.getItem(notifKey) && window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
            try {
                window.NotificationCenter.add({
                    type: 'warning',
                    title: 'Suscripci\u00f3n por expirar',
                    message: `Tu suscripci\u00f3n expira en ${daysLeft} d\u00eda${daysLeft !== 1 ? 's' : ''}. Renueva para mantener acceso completo.`,
                    action: () => {
                        window.location.href = '/perfil?tab=billing';
                    }
                });
            } catch (e) {}
            sessionStorage.setItem(notifKey, 'true');
        }
    }
}

// DOM handlers para el formulario admin
document.addEventListener('DOMContentLoaded', () => {
    // Defensive: ensure known modals are hidden on load to avoid accidental exposure
    try {
        const modalIds = [
            'userInfoModal', 'accountModal', 'adminModal', 'adminAuthModal',
            'importModal', 'dayModal', 'settingsModal', 'confirmDeleteModal'
        ];
        modalIds.forEach(id => {
            const el = document.getElementById(id);
            if (el) {
                el.style.display = 'none';
                el.classList.remove('user-panel');
                el.classList.remove('show');
            }
        });
    } catch (e) {}

    // Mostrar advertencia de expiraci�n
    setTimeout(showExpirationWarning, 1000);
    
    const adminForm = document.getElementById('adminForm');
    const adminModal = document.getElementById('adminModal');
    const adminClose = document.getElementById('adminClose');
    const adminTokenResult = document.getElementById('adminTokenResult');
    const adminCopyBtn = document.getElementById('adminCopyBtn');
    
    // ? SOPORTE PARA SELECTOR DE D�AS - MEJORADO
    const dayButtons = document.querySelectorAll('[data-days]');
    const expiresInput = document.getElementById('adminExpires');
    
    // Improve: do not inject inline styles. Toggle an active class and aria-pressed instead
    dayButtons.forEach(btn => {
        // Accessibility: treat as toggle buttons
        try { btn.setAttribute('role', 'button'); } catch (e) {}
        try { btn.setAttribute('aria-pressed', 'false'); } catch (e) {}

        btn.addEventListener('click', () => {
            const days = parseInt(btn.dataset.days);
            const expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + days);

            if (expiresInput) {
                // Convert to datetime-local without seconds/millis
                const year = expireDate.getFullYear();
                const month = String(expireDate.getMonth() + 1).padStart(2, '0');
                const day = String(expireDate.getDate()).padStart(2, '0');
                const hours = String(expireDate.getHours()).padStart(2, '0');
                const minutes = String(expireDate.getMinutes()).padStart(2, '0');

                expiresInput.value = `${year}-${month}-${day}T${hours}:${minutes}`;
            }

            // Toggle active state via class + aria attribute (styles live in CSS)
            dayButtons.forEach(b => {
                b.classList.remove('active');
                try { b.setAttribute('aria-pressed', 'false'); } catch (e) {}
            });

            btn.classList.add('active');
            try { btn.setAttribute('aria-pressed', 'true'); } catch (e) {}
        });
    });
    
    // ? Establecer valor por defecto: 7 d�as
    setTimeout(() => {
        const defaultBtn = document.querySelector('[data-days="7"]');
        if (defaultBtn) defaultBtn.click();
    }, 100);

       if (adminForm) {
       adminForm.addEventListener('submit', async (ev) => {
           ev.preventDefault();
           try {
               const email = (document.getElementById('adminEmail') || {}).value || '';
               const username = (document.getElementById('adminUsername') || {}).value || '';
               const expiresRaw = (document.getElementById('adminExpires') || {}).value || null;
               const maxUsesRaw = (document.getElementById('adminMaxUses') || {}).value;
               const maxUses = Number(maxUsesRaw) || 1;
               const adminPlan = (document.getElementById('adminPlan') || {}).value || 'free';
               let notes = (document.getElementById('adminNotes') || {}).value || '';
   
               if (!email) {
                  window.showAlert('Email Requerido', 'Email requerido para generar token', 'warning');
                   return;
               }
   
               // ?? Agregar plan a las notas si no est� ya incluido
               if (!notes.toLowerCase().includes('plan:')) {
                   notes = notes.trim() ? `${notes} | plan:${adminPlan}` : `plan:${adminPlan}`;
               }
   
               // ? CONVERTIR datetime-local a ISO string si existe
               let expires = null;
               if (expiresRaw) {
                   const expireDate = new Date(expiresRaw);
                   expires = expireDate.toISOString();
               }
   
              window.showAlert('Generando token...', 'info', 2000);

               const token = await createAccessToken({ 
                   email, 
                   username, 
                   expiresAt: expires, 
                   maxUses, 
                   notes 
               });

               if (adminTokenResult) {
                   adminTokenResult.textContent = token;
               }

               if (adminCopyBtn) {
                   adminCopyBtn.style.display = 'inline-block';
                   adminCopyBtn.onclick = async () => {
                       try {
                           await navigator.clipboard.writeText(token);
                          window.showAlert('Token Copiado', 'Token copiado al portapapeles', 'success', 3000);
                       } catch (err) {
                          window.showAlert('Error al Copiar', 'No se pudo copiar el token', 'error');
                       }
                   };
               }

              window.showAlert('Token Generado', 'Token generado correctamente', 'success', 4000);
   
           } catch (err) {
               // No mostrar alerta duplicada si ya se mostr� en createAccessToken
               if (!err.message.includes('Admin secret')) {
                  window.showAlert('Error generando token: ' + (err.message || err), 'error');
               }
           }
       });
   }

    if (adminClose && adminModal) {
        adminClose.addEventListener('click', () => {
            // Hide the admin modal
            // Remove visible class and also explicitly hide the element to avoid
            // leaving a leftover visible element when CSS/class state gets out of sync.
            adminModal.classList.remove('show');
            try { adminModal.style.display = 'none'; } catch (e) {}
            adminModal.setAttribute('aria-hidden', 'true');

            // Cleanup any auxiliary overlays that might have been left open
            try {
                // remove any confirmation/prompt overlays
                document.querySelectorAll('.custom-confirm-overlay, #customConfirm, #customPrompt').forEach(el => el.remove());

                // hide floating user panel if accidentally left open
                const userModal = document.getElementById('userInfoModal');
                if (userModal) {
                    userModal.style.display = 'none';
                    userModal.classList.remove('user-panel');
                    userModal.classList.remove('show');
                }

                // clear token result and hide copy button
                const adminTokenResult = document.getElementById('adminTokenResult');
                if (adminTokenResult) adminTokenResult.textContent = '';
                const adminCopyBtn = document.getElementById('adminCopyBtn');
                if (adminCopyBtn) adminCopyBtn.style.display = 'none';
                
                // Also ensure the admin auth modal (header) is closed
                try { if (window.closeAdminAuthModal && typeof window.closeAdminAuthModal === 'function') window.closeAdminAuthModal(); } catch (e) {}
            } catch (e) {}
        });
    }
});

// ============================================
// ?? PAYPAL CHECKOUT + PORTAL
// ============================================
export async function initiatePayPalCheckout(plan) {
    if (window.initiateCheckout && typeof window.initiateCheckout === 'function') {
        return window.initiateCheckout(plan);
    }

    if (window.showAlert) {
        window.showAlert('PayPal no disponible', 'El sistema de pagos no está configurado aún.', 'error');
    }
}

// ============================================
// ?? CANCEL PAYPAL SUBSCRIPTION (Endpoint activo)
// ============================================
export async function cancelPayPalSubscription() {
    const userPlan = localStorage.getItem('userPlan') || 'free';

    if (userPlan === 'free') {
        if (window.showAlert) {
            window.showAlert('Plan Gratis', 'No hay suscripción activa para cancelar', 'info');
        }
        return;
    }

    // Confirmación antes de cancelar
    if (window.showConfirm) {
        window.showConfirm(
            'Cancelar Suscripción',
            '¿Estás seguro de que deseas cancelar tu suscripción? Pasarás al plan FREE inmediatamente.',
            async () => {
                try {
                    if (window.showToast) {
                        window.showToast('Cancelando suscripción...', 'info');
                    }

                    // Obtener token del usuario
                    const token = localStorage.getItem('userToken') || await createAccessToken();
                    
                    if (!token) {
                        if (window.showAlert) {
                            window.showAlert('Error', 'No se encontró token de sesión', 'error');
                        }
                        return;
                    }

                    // Llamar al nuevo endpoint para cancelar en PayPal
                    const response = await fetch('/api/cancel-paypal-subscription', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        if (window.showAlert) {
                            window.showAlert('Error', data.error || 'No se pudo cancelar la suscripción', 'error');
                        }
                        return;
                    }

                    if (data.success) {
                        // Actualizar estado local INMEDIATAMENTE
                        localStorage.setItem('userPlan', 'free');
                        localStorage.removeItem('paypalSubscriptionId');
                        localStorage.removeItem('tfx_paypalSubId');
                        localStorage.removeItem('expires_at');

                        // Actualizar UI en tiempo real
                        const planEl = document.getElementById('userInfoPlan');
                        if (planEl) planEl.textContent = 'FREE';

                        const cancelSubBtn = document.getElementById('cancelSubscriptionBtn');
                        if (cancelSubBtn) cancelSubBtn.style.display = 'none';

                        const upgradePlanBtn = document.getElementById('upgradePlanBtn');
                        if (upgradePlanBtn) upgradePlanBtn.style.display = 'block';

                        const statusEl = document.getElementById('userInfoPlanStatus');
                        if (statusEl) {
                            statusEl.textContent = 'Inactiva';
                            statusEl.style.color = '#f44336';
                        }

                        const statusDotEl = document.querySelector('.status-dot');
                        if (statusDotEl) {
                            statusDotEl.style.background = '#f44336';
                            statusDotEl.style.boxShadow = '0 0 12px #f44336';
                        }

                        if (window.showAlert) {
                            window.showAlert('Éxito', 'Tu suscripción ha sido cancelada. Tu plan es ahora FREE.', 'success');
                        }

                        // Recargar página para sincronizar completamente con BD
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                } catch (error) {
                    if (window.showAlert) {
                        window.showAlert('Error', 'Error al cancelar: ' + error.message, 'error');
                    }
                }
            }
        );
    }
}

export async function openPayPalPortal() {
    const userPlan = localStorage.getItem('userPlan') || 'free';

    if (userPlan === 'free') {
        if (window.showAlert) {
            window.showAlert('Plan Gratis', 'El plan FREE no tiene suscripción activa', 'info');
        }
        return;
    }

    if (window.showToast) {
        window.showToast('Abriendo PayPal...', 'info');
    }

    const env = (window.PAYPAL_ENV || 'live').toLowerCase();
    const portalUrl = env === 'sandbox'
        ? 'https://www.sandbox.paypal.com/myaccount/autopay/'
        : 'https://www.paypal.com/myaccount/autopay/';

    if (window.closeUserInfoModal) {
        window.closeUserInfoModal();
    }

    window.open(portalUrl, '_blank');
}

// Aliases para compatibilidad
export const openStripePortal = openPayPalPortal;
export const initiateStripeCheckout = initiatePayPalCheckout;

// ============================================
// ?? USER DROPDOWN MENU
// ============================================

export function toggleUserMenu(event) {
    event.stopPropagation();
    const dropdown = document.getElementById('userDropdownMenu');
    if (dropdown) {
        const isVisible = dropdown.style.display !== 'none';
        dropdown.style.display = isVisible ? 'none' : 'block';
    }
}

// Close dropdown when clicking outside
document.addEventListener('click', (e) => {
    const dropdown = document.getElementById('userDropdownMenu');
    const userBtn = document.querySelector('.user-info-btn');
    if (dropdown && userBtn && !userBtn.contains(e.target) && !dropdown.contains(e.target)) {
        dropdown.style.display = 'none';
    }
});

// Expose helpers globally
// NOTA: showAlert y showConfirm vienen de notifications.js, no sobrescribir
try {
    // Solo asignar funciones que SÍ están definidas en este archivo
    window.showPrompt = showPrompt;
    window.showUserInfo = showUserInfo;
    window.closeUserInfoModal = closeUserInfoModal;
    window.goToPlans = goToPlans;
    window.logoutUser = logoutUser;
    window.createAccessToken = createAccessToken;
    window.showExpirationWarning = showExpirationWarning;
    window.forceLogout = forceLogout;
    window.openStripePortal = openStripePortal;
    window.initiateStripeCheckout = initiateStripeCheckout;
    window.openPayPalPortal = openPayPalPortal;
    window.cancelPayPalSubscription = cancelPayPalSubscription;
    window.initiatePayPalCheckout = initiatePayPalCheckout;
    window.showChangePasswordForm = showChangePasswordForm;
    window.hideChangePasswordForm = hideChangePasswordForm;
    window.handleChangePassword = handleChangePassword;
    window.toggleUserMenu = toggleUserMenu;

    // Inicializar información del usuario al cargar la página
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => showUserInfo(), 100);
        });
    } else {
        setTimeout(() => showUserInfo(), 100);
    }

} catch (e) {}

